import { useState, useEffect } from 'react';
import { SubscriptionsApiType, SubscriptionLineType } from '../types/api/subscriptions-api-type';
import { ProductInfoViewType } from '../types/view/product-info-view-type';

const createProductInfo = (
  line: SubscriptionLineType,
  active: boolean
): ProductInfoViewType => {
  return {
    productTitle: line.title,
    image: line.variantImage,
    variantTitle: line.variantTitle,
    originalPrice: line.lineDiscountedPriceAmount,
    price: line.currentPriceAmount,
    quantity: line.quantity,
    variantId: line.variantId,
    lineId: line.lineId,
    url: line.onlineStorePreviewUrl,
    active,
  };
};

export const useRegisteredProduct = (subscriptions: SubscriptionsApiType) => {
  const [registeredProducts, setRegisteredProducts] = useState<ProductInfoViewType[]>([]);

  useEffect(() => {
    const actives = subscriptions.filter(subscription => subscription.status === 'ACTIVE');

    if (actives.length === 0) {
      setRegisteredProducts([]);
      return;
    }

    const products = actives[0].subscriptionLines.map(subscriptionLine => {
      return createProductInfo(subscriptionLine, true);
    });

    setRegisteredProducts(products);

  }, [subscriptions]);

  return registeredProducts;
};

